import NewsBox from './LearnMore/NewsBox'
import settings from 'settings'
import whatsNewThumbnail from 'assets/img/home/helpPanel/whatsnew-thumbnail.svg'

import { Box, List, styled } from '@mui/material'
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined'
import BookOutlinedIcon from '@mui/icons-material/BookOutlined'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import intl from 'app/localization/intl'
import FooterItem from './FooterItem'

const FooterWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}))

const FooterListStyled = styled(List)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column'
  }
}))

export function HelpFooter() {
  return (
    <FooterWrapper>
      <Box>
        <NewsBox
          title={intl.formatMessage({ id: 'helpPanel.newsTitle' })}
          description={intl.formatMessage({ id: 'helpPanel.newsSubtitle' })}
          link={`${settings.documentationUrl}/whats-new`}
          image={whatsNewThumbnail}
        />
      </Box>

      <FooterListStyled>
        <FooterItem
          id="carto-academy"
          icon={<SchoolOutlinedIcon />}
          href={settings.cartoAcademyUrl}
          textId="helpPanel.academy"
        />
        <FooterItem
          id="documentation"
          icon={<BookOutlinedIcon />}
          href={settings.documentationUrl}
          textId="helpPanel.documentation"
        />
        <FooterItem
          id="contact-us"
          icon={<MailOutlineIcon />}
          href={`mailto:${settings.supportEmail}`}
          textId="helpPanel.contactUs"
        />
      </FooterListStyled>
    </FooterWrapper>
  )
}

export default HelpFooter
